import { Box } from '@mui/material';
import { DashboardContent } from 'src/layouts/dashboard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionGuard } from 'src/routes/components';
import { useLocale } from 'react-admin';
import { useMemo } from 'react';

const Views = () => {
  const locale = useLocale();
  const lookerAnalyticsUrl = useMemo(() => {
    return locale === 'en'
      ? process.env.REACT_APP_GA_REPORTING_EN
      : process.env.REACT_APP_GA_REPORTING_ZH;
  }, [locale]);
  return (
    <PermissionGuard resource="analytics" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent sx={{ paddingBottom: '0' }}>
        <Box sx={{ width: '100%', overflowX: 'scroll', overflowY: 'hidden' }}>
          <Box sx={{ height: '3200px', width: '1400px' }}>
            <iframe
              title="Analytics Dashboard"
              src={lookerAnalyticsUrl}
              style={{ border: 'none', width: '100%', height: '100%' }}
            />
          </Box>
        </Box>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default Views;